import {Injectable} from '@angular/core';
import {BaseService} from "../../../../services/base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {MatSidenav} from "@angular/material/sidenav";



@Injectable({
    providedIn: 'root'
})
export class SideBarService extends BaseService {


    private sidenav: MatSidenav;

    constructor() {
        super();
    }


    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
    }

    public open() {
        return this.sidenav.open();
    }


    public close() {
        return this.sidenav.close();
    }

    public toggle(): void {
        this.sidenav.toggle();
    }




}
